import React from 'react'

import * as Yup from 'yup'
import { Form, Input } from 'formik-antd'
import { BasicForm } from '../../../../core/components/form'
import { usePostForm } from '../../../../hooks/admin/templateFolder'
import { useHistory } from 'react-router-dom'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'
import DirectoryStructure from './directory'

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name cannot be blank.')
})

const Formulario = () => {
  const create = usePostForm()
  const history = useHistory()

  const onPressBack = () => history.goBack()

  function handleSubmit (values, bag) {
    const form = { ...values }

    create.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const initialValues = {
    name: '',
    description: '',
    structure: []
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='TEMPLATE FOLDER'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={({ values, setFieldValue }) => (
        <>
          <Form.Item name='name' label='Name' required>
            <Input name='name' />
          </Form.Item>

          <Form.Item name='description' label='Description'>
            <Input.TextArea name='description' rows={5} />
          </Form.Item>
          <Form.Item name='structure' label='Folder structure'>
            <DirectoryStructure
              onChange={(value) => setFieldValue('structure', value)}
              value={values.structure}
            />
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
